webpackJsonp([6,33,34,60,169,170,171,299],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(959),
  /* template */
  __webpack_require__(960),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(962),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(963),
  /* template */
  __webpack_require__(964),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(965),
  /* template */
  __webpack_require__(966),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(967),
  /* template */
  __webpack_require__(968),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(969),
  /* template */
  __webpack_require__(970),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_autocomplete__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExObjArray__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExObjArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExObjArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExObjArray__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExObjArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExObjArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExHeader__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__examples_ExHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExHeader__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExFooter__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__examples_ExFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFooter__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExCustomAsync__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExCustomAsync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__examples_ExCustomAsync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExCustomAsync__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExCustomAsync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExCustomAsync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExInfiniteScroll__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExInfiniteScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__examples_ExInfiniteScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExInfiniteScroll__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExInfiniteScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExInfiniteScroll__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_autocomplete__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a,
            ExObjArrayCode: __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExObjArray___default.a,
            ExObjArray: __WEBPACK_IMPORTED_MODULE_3__examples_ExObjArray___default.a,
            ExHeader: __WEBPACK_IMPORTED_MODULE_5__examples_ExHeader___default.a,
            ExHeaderCode: __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExHeader___default.a,
            ExFooter: __WEBPACK_IMPORTED_MODULE_7__examples_ExFooter___default.a,
            ExFooterCode: __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExFooter___default.a,
            ExCustomAsyncCode: __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExCustomAsync___default.a,
            ExCustomAsync: __WEBPACK_IMPORTED_MODULE_9__examples_ExCustomAsync___default.a,
            ExInfiniteScroll: __WEBPACK_IMPORTED_MODULE_11__examples_ExInfiniteScroll___default.a,
            ExInfiniteScrollCode: __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExInfiniteScroll___default.a
        };
    }
});

/***/ }),

/***/ 1311:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <p class=\"content\"><b>Selected:</b> {{ selected }}</p>\n        <b-field label=\"Find a JS framework\">\n            <b-autocomplete\n                rounded\n                v-model=\"name\"\n                :data=\"filteredDataArray\"\n                placeholder=\"e.g. jQuery\"\n                icon=\"magnify\"\n                @select=\"option => selected = option\">\n                <template slot=\"empty\">No results found</template>\n            </b-autocomplete>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [\n                    'Angular',\n                    'Angular 2',\n                    'Aurelia',\n                    'Backbone',\n                    'Ember',\n                    'jQuery',\n                    'Meteor',\n                    'Node.js',\n                    'Polymer',\n                    'React',\n                    'RxJS',\n                    'Vue.js'\n                ],\n                name: '',\n                selected: null\n            }\n        },\n        computed: {\n            filteredDataArray() {\n                return this.data.filter((option) => {\n                    return option\n                        .toString()\n                        .toLowerCase()\n                        .indexOf(this.name.toLowerCase()) >= 0\n                })\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1312:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"block\">\n            <b-switch v-model=\"openOnFocus\">\n                Open dropdown on focus\n            </b-switch>\n            <b-switch v-model=\"keepFirst\">\n                Keep-first <small>(will always have first option pre-selected)</small>\n            </b-switch>\n        </div>\n        <p class=\"content\"><b>Selected:</b> {{ selected }}</p>\n        <b-field label=\"Find a name\">\n            <b-autocomplete\n                v-model=\"name\"\n                placeholder=\"e.g. Anne\"\n                :keep-first=\"keepFirst\"\n                :open-on-focus=\"openOnFocus\"\n                :data=\"filteredDataObj\"\n                field=\"user.first_name\"\n                @select=\"option => selected = option\">\n            </b-autocomplete>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    const data = require('@/data/sample.json')\n\n    export default {\n        data() {\n            return {\n                data,\n                keepFirst: false,\n                openOnFocus: false,\n                name: '',\n                selected: null\n            }\n        },\n        computed: {\n            filteredDataObj() {\n                return this.data.filter((option) => {\n                    return option.user.first_name\n                        .toString()\n                        .toLowerCase()\n                        .indexOf(this.name.toLowerCase()) >= 0\n                })\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1313:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <p class=\"content\"><b>Selected:</b> {{ selected }}</p>\n        <b-field label=\"Find or add a Fruit\">\n            <b-autocomplete\n                v-model=\"name\"\n                ref=\"autocomplete\"\n                :data=\"filteredDataArray\"\n                placeholder=\"e.g. Orange\"\n                @select=\"option => selected = option\">\n                <template slot=\"header\">\n                    <a @click=\"showAddFruit\">\n                        <span> Add new... </span>\n                    </a> \n                </template>\n                <template slot=\"empty\">No results for {{name}}</template>\n            </b-autocomplete>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [\n                    'Orange',\n                    'Apple',\n                    'Banana',\n                    'Pear',\n                    'Lemon',\n                    'Strawberry',\n                    'Kiwi'\n                ],\n                name: '',\n                selected: null\n            }\n        },\n        computed: {\n            filteredDataArray() {\n                return this.data.filter((option) => {\n                    return option\n                        .toString()\n                        .toLowerCase()\n                        .indexOf(this.name.toLowerCase()) >= 0\n                })\n            }\n        },\n        methods: {\n            showAddFruit() {\n                this.$buefy.dialog.prompt({\n                    message: `Fruit`,\n                    inputAttrs: {\n                        placeholder: 'e.g. Watermelon',\n                        maxlength: 20,\n                        value: this.name\n                    },\n                    confirmText: 'Add',\n                    onConfirm: (value) => {\n                        this.data.push(value)\n                        this.$refs.autocomplete.setSelected(value)\n                    }\n                })\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1314:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <p class=\"content\"><b>Selected:</b> {{ selected }}</p>\n        <b-field label=\"Find or add a Fruit\">\n            <b-autocomplete\n                v-model=\"name\"\n                ref=\"autocomplete\"\n                :data=\"filteredDataArray\"\n                placeholder=\"e.g. Orange\"\n                @select=\"option => selected = option\">\n                <template slot=\"footer\">\n                    <a @click=\"showAddFruit\">\n                        <span> Add new... </span>\n                    </a> \n                </template>\n                <template slot=\"empty\">No results for {{name}}</template>\n            </b-autocomplete>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                data: [\n                    'Orange',\n                    'Apple',\n                    'Banana',\n                    'Pear',\n                    'Lemon',\n                    'Strawberry',\n                    'Kiwi'\n                ],\n                name: '',\n                selected: null\n            }\n        },\n        computed: {\n            filteredDataArray() {\n                return this.data.filter((option) => {\n                    return option\n                        .toString()\n                        .toLowerCase()\n                        .indexOf(this.name.toLowerCase()) >= 0\n                })\n            }\n        },\n        methods: {\n            showAddFruit() {\n                this.$buefy.dialog.prompt({\n                    message: `Fruit`,\n                    inputAttrs: {\n                        placeholder: 'e.g. Watermelon',\n                        maxlength: 20,\n                        value: this.name\n                    },\n                    confirmText: 'Add',\n                    onConfirm: (value) => {\n                        this.data.push(value)\n                        this.$refs.autocomplete.setSelected(value)\n                    }\n                })\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1315:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <p class=\"content\"><b>Selected:</b> {{ selected }}</p>\n        <b-field label=\"Find a movie\">\n            <b-autocomplete\n                :data=\"data\"\n                placeholder=\"e.g. Fight Club\"\n                field=\"title\"\n                :loading=\"isFetching\"\n                @typing=\"getAsyncData\"\n                @select=\"option => selected = option\">\n\n                <template slot-scope=\"props\">\n                    <div class=\"media\">\n                        <div class=\"media-left\">\n                            <img width=\"32\" :src=\"`https://image.tmdb.org/t/p/w500/${props.option.poster_path}`\">\n                        </div>\n                        <div class=\"media-content\">\n                            {{ props.option.title }}\n                            <br>\n                            <small>\n                                Released at {{ props.option.release_date }},\n                                rated <b>{{ props.option.vote_average }}</b>\n                            </small>\n                        </div>\n                    </div>\n                </template>\n            </b-autocomplete>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    import debounce from 'lodash/debounce'\n\n    export default {\n        data() {\n            return {\n                data: [],\n                selected: null,\n                isFetching: false\n            }\n        },\n        methods: {\n            // You have to install and import debounce to use it,\n            // it's not mandatory though.\n            getAsyncData: debounce(function (name) {\n                if (!name.length) {\n                    this.data = []\n                    return\n                }\n                this.isFetching = true\n                this.$http.get(`https://api.themoviedb.org/3/search/movie?api_key=bb6f51bef07465653c3e553d6ab161a8&query=${name}`)\n                    .then(({ data }) => {\n                        this.data = []\n                        data.results.forEach((item) => this.data.push(item))\n                    })\n                    .catch((error) => {\n                        this.data = []\n                        throw error\n                    })\n                    .finally(() => {\n                        this.isFetching = false\n                    })\n            }, 500)\n        }\n    }\n</script>"

/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <p class=\"content\"><b>Selected:</b> {{ selected }}</p>\n        <b-field label=\"Find a movie\">\n            <b-autocomplete\n                :data=\"data\"\n                placeholder=\"e.g. Fight Club\"\n                field=\"title\"\n                :loading=\"isFetching\"\n                :check-infinite-scroll=\"true\"\n                @typing=\"getAsyncData\"\n                @select=\"option => selected = option\"\n                @infinite-scroll=\"getMoreAsyncData\">\n\n                <template slot-scope=\"props\">\n                    <div class=\"media\">\n                        <div class=\"media-left\">\n                            <img width=\"32\" :src=\"`https://image.tmdb.org/t/p/w500/${props.option.poster_path}`\">\n                        </div>\n                        <div class=\"media-content\">\n                            {{ props.option.title }}\n                            <br>\n                            <small>\n                                Released at {{ props.option.release_date }},\n                                rated <b>{{ props.option.vote_average }}</b>\n                            </small>\n                        </div>\n                    </div>\n                </template>\n                <template slot=\"footer\">\n                    <span v-show=\"page > totalPages\" class=\"has-text-grey\"> Thats it! No more movies found. </span>\n                </template>\n            </b-autocomplete>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    import debounce from 'lodash/debounce'\n\n    export default {\n        data() {\n            return {\n                data: [],\n                selected: null,\n                isFetching: false,\n                name: '',\n                page: 1,\n                totalPages: 1\n            }\n        },\n        methods: {\n            // You have to install and import debounce to use it,\n            // it's not mandatory though.\n            getAsyncData: debounce(function (name) {\n                // String update\n                if (this.name !== name) {\n                    this.name = name\n                    this.data = []\n                    this.page = 1\n                    this.totalPages = 1\n                }\n                // String cleared\n                if (!name.length) {\n                    this.data = []\n                    this.page = 1\n                    this.totalPages = 1\n                    return\n                }\n                // Reached last page\n                if (this.page > this.totalPages) {\n                    return\n                }\n                this.isFetching = true\n                this.$http.get(`https://api.themoviedb.org/3/search/movie?api_key=bb6f51bef07465653c3e553d6ab161a8&query=${name}&page=${this.page}`)\n                    .then(({ data }) => {\n                        data.results.forEach((item) => this.data.push(item))\n                        \n                        this.page++\n                        this.totalPages = data.total_pages\n                    })\n                    .catch((error) => {\n                        throw error\n                    })\n                    .finally(() => {\n                        this.isFetching = false\n                    })\n            }, 500),\n            getMoreAsyncData: debounce(function () {\n                this.getAsyncData(this.name)\n            }, 250)\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1317:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExObjArray,
      "code": _vm.ExObjArrayCode,
      "title": "Object array"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExHeader,
      "code": _vm.ExHeaderCode,
      "title": "Header"
    }
  }, [_c('p', [_vm._v("You can add your custom header to the autocomplete.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExFooter,
      "code": _vm.ExFooterCode,
      "title": "Footer"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])]), _vm._v(" "), _c('p', [_vm._v("You can add your custom footer to the autocomplete.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomAsync,
      "code": _vm.ExCustomAsyncCode,
      "title": "Async with custom template"
    }
  }, [_c('p', [_vm._v("You can have a custom template by adding a scoped slot to it.")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("API from "), _c('a', {
    attrs: {
      "href": "https://www.themoviedb.org",
      "target": "_blank"
    }
  }, [_vm._v("TMDb")])]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExInfiniteScroll,
      "code": _vm.ExInfiniteScrollCode,
      "title": "Async with infinite scroll"
    }
  }, [_c('p', [_vm._v("With "), _c('code', [_vm._v("check-infinite-scroll")]), _vm._v(" and "), _c('code', [_vm._v("infinite-scroll")]), _vm._v(" event you can listen to the end of the scroll list to implement an infinite scroll strategy.")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("API from "), _c('a', {
    attrs: {
      "href": "https://www.themoviedb.org",
      "target": "_blank"
    }
  }, [_vm._v("TMDb")])]), _vm._v(".")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1310),
  /* template */
  __webpack_require__(1317),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 902:
/***/ (function(module, exports) {

module.exports = [{"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016/10/15 13:43:27","gender":"Male"},{"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016/12/15 06:00:53","gender":"Male"},{"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016/04/26 06:26:28","gender":"Female"},{"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016/04/10 10:28:46","gender":"Male"},{"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016/12/06 14:38:38","gender":"Female"},{"id":6,"user":{"first_name":"Sara","last_name":"Armstrong"},"date":"2016/09/23 18:50:04","gender":"Female"},{"id":7,"user":{"first_name":"Anthony","last_name":"Webb"},"date":"2016/08/30 23:49:38","gender":"Male"},{"id":8,"user":{"first_name":"Andrew","last_name":"Greene"},"date":"2016/11/20 14:57:47","gender":"Male"},{"id":9,"user":{"first_name":"Russell","last_name":"White"},"date":"2016/07/13 09:29:49","gender":"Male"},{"id":10,"user":{"first_name":"Lori","last_name":"Hunter"},"date":"2016/12/09 01:44:05","gender":"Female"},{"id":11,"user":{"first_name":"Ronald","last_name":"Wood"},"date":"2016/12/04 02:23:48","gender":"Male"},{"id":12,"user":{"first_name":"Michael","last_name":"Harper"},"date":"2016/07/27 13:28:15","gender":"Male"},{"id":13,"user":{"first_name":"George","last_name":"Dunn"},"date":"2017/03/07 12:26:52","gender":"Male"},{"id":14,"user":{"first_name":"Eric","last_name":"Rogers"},"date":"2016/06/07 05:41:52","gender":"Male"},{"id":15,"user":{"first_name":"Juan","last_name":"Meyer"},"date":"2017/02/01 04:56:34","gender":"Male"},{"id":16,"user":{"first_name":"Lori","last_name":"Shaw"},"date":"2017/01/26 11:50:04","gender":"Female"},{"id":17,"user":{"first_name":"Lori","last_name":"Cunningham"},"date":"2016/05/01 10:00:56","gender":"Female"},{"id":18,"user":{"first_name":"Charles","last_name":"Graham"},"date":"2016/05/31 06:43:30","gender":"Male"},{"id":19,"user":{"first_name":"Henry","last_name":"Morrison"},"date":"2016/09/27 16:15:44","gender":"Male"},{"id":20,"user":{"first_name":"Albert","last_name":"Mendoza"},"date":"2016/08/08 05:29:24","gender":"Male"},{"id":21,"user":{"first_name":"Ruby","last_name":"Snyder"},"date":"2017/04/01 12:04:39","gender":"Female"},{"id":22,"user":{"first_name":"Jesse","last_name":"Warren"},"date":"2016/08/20 01:36:38","gender":"Male"},{"id":23,"user":{"first_name":"Carlos","last_name":"Ferguson"},"date":"2016/05/31 10:40:29","gender":"Male"},{"id":24,"user":{"first_name":"Melissa","last_name":"Peters"},"date":"2016/07/23 00:41:54","gender":"Female"},{"id":25,"user":{"first_name":"Arthur","last_name":"Garza"},"date":"2017/03/11 14:11:37","gender":"Male"},{"id":26,"user":{"first_name":"Joe","last_name":"Berry"},"date":"2016/07/09 15:16:56","gender":"Male"},{"id":27,"user":{"first_name":"Joseph","last_name":"Bishop"},"date":"2016/10/04 19:44:54","gender":"Male"},{"id":28,"user":{"first_name":"Sarah","last_name":"Harper"},"date":"2016/09/23 05:09:11","gender":"Female"},{"id":29,"user":{"first_name":"Christopher","last_name":"Fuller"},"date":"2016/04/12 00:05:35","gender":"Male"},{"id":30,"user":{"first_name":"Alan","last_name":"Mendoza"},"date":"2016/04/22 10:48:02","gender":"Male"},{"id":31,"user":{"first_name":"James","last_name":"Davis"},"date":"2017/01/16 15:17:03","gender":"Male"},{"id":32,"user":{"first_name":"Scott","last_name":"Welch"},"date":"2016/10/04 23:31:51","gender":"Male"},{"id":33,"user":{"first_name":"Mildred","last_name":"Myers"},"date":"2016/11/23 13:46:18","gender":"Female"},{"id":34,"user":{"first_name":"Victor","last_name":"Martinez"},"date":"2016/04/06 17:05:07","gender":"Male"},{"id":35,"user":{"first_name":"Susan","last_name":"Medina"},"date":"2016/12/09 10:33:37","gender":"Female"},{"id":36,"user":{"first_name":"Judy","last_name":"Long"},"date":"2016/07/26 16:19:04","gender":"Female"},{"id":37,"user":{"first_name":"Joan","last_name":"Myers"},"date":"2016/09/22 04:55:54","gender":"Female"},{"id":38,"user":{"first_name":"Rachel","last_name":"Gonzales"},"date":"2016/07/15 13:56:38","gender":"Female"},{"id":39,"user":{"first_name":"Roger","last_name":"Hunt"},"date":"2016/08/14 10:43:11","gender":"Male"},{"id":40,"user":{"first_name":"Dorothy","last_name":"Howard"},"date":"2016/06/19 05:34:49","gender":"Female"},{"id":41,"user":{"first_name":"Eugene","last_name":"Lynch"},"date":"2016/12/24 08:19:24","gender":"Male"},{"id":42,"user":{"first_name":"Kathy","last_name":"Webb"},"date":"2017/04/01 21:09:05","gender":"Female"},{"id":43,"user":{"first_name":"Antonio","last_name":"White"},"date":"2017/02/10 06:51:20","gender":"Male"},{"id":44,"user":{"first_name":"Louis","last_name":"Spencer"},"date":"2016/10/08 02:20:22","gender":"Male"},{"id":45,"user":{"first_name":"Andrea","last_name":"Marshall"},"date":"2016/09/04 10:59:57","gender":"Female"},{"id":46,"user":{"first_name":"Eugene","last_name":"Sims"},"date":"2017/03/15 06:39:48","gender":"Male"},{"id":47,"user":{"first_name":"Mildred","last_name":"Gibson"},"date":"2016/04/18 06:43:54","gender":"Female"},{"id":48,"user":{"first_name":"Joan","last_name":"Arnold"},"date":"2016/12/16 04:52:23","gender":"Female"},{"id":49,"user":{"first_name":"Jesse","last_name":"Schmidt"},"date":"2016/06/11 02:44:33","gender":"Male"},{"id":50,"user":{"first_name":"David","last_name":"Frazier"},"date":"2017/02/15 21:46:30","gender":"Male"},{"id":51,"user":{"first_name":"Nicholas","last_name":"Howell"},"date":"2016/11/01 15:08:31","gender":"Male"},{"id":52,"user":{"first_name":"Douglas","last_name":"Chapman"},"date":"2017/02/08 03:33:24","gender":"Male"},{"id":53,"user":{"first_name":"Bruce","last_name":"Simmons"},"date":"2016/07/14 12:11:17","gender":"Male"},{"id":54,"user":{"first_name":"Antonio","last_name":"George"},"date":"2016/11/07 19:12:55","gender":"Male"},{"id":55,"user":{"first_name":"Chris","last_name":"Marshall"},"date":"2016/07/03 12:11:45","gender":"Male"},{"id":56,"user":{"first_name":"Ashley","last_name":"Hudson"},"date":"2016/10/14 21:08:05","gender":"Female"},{"id":57,"user":{"first_name":"Alan","last_name":"Edwards"},"date":"2017/03/22 21:10:25","gender":"Male"},{"id":58,"user":{"first_name":"George","last_name":"Clark"},"date":"2016/04/28 03:15:05","gender":"Male"},{"id":59,"user":{"first_name":"Frank","last_name":"Porter"},"date":"2016/09/08 00:48:14","gender":"Male"},{"id":60,"user":{"first_name":"Christopher","last_name":"Palmer"},"date":"2016/05/24 08:58:12","gender":"Male"}]

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(917);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(904);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(903),
    now = __webpack_require__(916),
    toNumber = __webpack_require__(918);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 916:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(904);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(903),
    isSymbol = __webpack_require__(919);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(920),
    isObjectLike = __webpack_require__(923);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(905),
    getRawTag = __webpack_require__(921),
    objectToString = __webpack_require__(922);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(905);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 922:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 923:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: ['Angular', 'Angular 2', 'Aurelia', 'Backbone', 'Ember', 'jQuery', 'Meteor', 'Node.js', 'Polymer', 'React', 'RxJS', 'Vue.js'],
            name: '',
            selected: null
        };
    },

    computed: {
        filteredDataArray: function filteredDataArray() {
            var _this = this;

            return this.data.filter(function (option) {
                return option.toString().toLowerCase().indexOf(_this.name.toLowerCase()) >= 0;
            });
        }
    }
});

/***/ }),

/***/ 960:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find a JS framework"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "rounded": "",
      "data": _vm.filteredDataArray,
      "placeholder": "e.g. jQuery",
      "icon": "magnify"
    },
    on: {
      "select": function (option) { return _vm.selected = option; }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("No results found")])], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 961:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _data = __webpack_require__(902);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: _data,
            keepFirst: false,
            openOnFocus: false,
            name: '',
            selected: null
        };
    },

    computed: {
        filteredDataObj: function filteredDataObj() {
            var _this = this;

            return this.data.filter(function (option) {
                return option.user.first_name.toString().toLowerCase().indexOf(_this.name.toLowerCase()) >= 0;
            });
        }
    }
});

/***/ }),

/***/ 962:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.openOnFocus),
      callback: function($$v) {
        _vm.openOnFocus = $$v
      },
      expression: "openOnFocus"
    }
  }, [_vm._v("\n                Open dropdown on focus\n            ")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.keepFirst),
      callback: function($$v) {
        _vm.keepFirst = $$v
      },
      expression: "keepFirst"
    }
  }, [_vm._v("\n                Keep-first "), _c('small', [_vm._v("(will always have first option pre-selected)")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find a name"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "placeholder": "e.g. Anne",
      "keep-first": _vm.keepFirst,
      "open-on-focus": _vm.openOnFocus,
      "data": _vm.filteredDataObj,
      "field": "user.first_name"
    },
    on: {
      "select": function (option) { return _vm.selected = option; }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 963:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: ['Orange', 'Apple', 'Banana', 'Pear', 'Lemon', 'Strawberry', 'Kiwi'],
            name: '',
            selected: null
        };
    },

    computed: {
        filteredDataArray: function filteredDataArray() {
            var _this = this;

            return this.data.filter(function (option) {
                return option.toString().toLowerCase().indexOf(_this.name.toLowerCase()) >= 0;
            });
        }
    },
    methods: {
        showAddFruit: function showAddFruit() {
            var _this2 = this;

            this.$buefy.dialog.prompt({
                message: 'Fruit',
                inputAttrs: {
                    placeholder: 'e.g. Watermelon',
                    maxlength: 20,
                    value: this.name
                },
                confirmText: 'Add',
                onConfirm: function onConfirm(value) {
                    _this2.data.push(value);
                    _this2.$refs.autocomplete.setSelected(value);
                }
            });
        }
    }
});

/***/ }),

/***/ 964:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find or add a Fruit"
    }
  }, [_c('b-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "data": _vm.filteredDataArray,
      "placeholder": "e.g. Orange"
    },
    on: {
      "select": function (option) { return _vm.selected = option; }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, [_c('template', {
    slot: "header"
  }, [_c('a', {
    on: {
      "click": _vm.showAddFruit
    }
  }, [_c('span', [_vm._v(" Add new... ")])])]), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_vm._v("No results for " + _vm._s(_vm.name))])], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 965:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: ['Orange', 'Apple', 'Banana', 'Pear', 'Lemon', 'Strawberry', 'Kiwi'],
            name: '',
            selected: null
        };
    },

    computed: {
        filteredDataArray: function filteredDataArray() {
            var _this = this;

            return this.data.filter(function (option) {
                return option.toString().toLowerCase().indexOf(_this.name.toLowerCase()) >= 0;
            });
        }
    },
    methods: {
        showAddFruit: function showAddFruit() {
            var _this2 = this;

            this.$buefy.dialog.prompt({
                message: 'Fruit',
                inputAttrs: {
                    placeholder: 'e.g. Watermelon',
                    maxlength: 20,
                    value: this.name
                },
                confirmText: 'Add',
                onConfirm: function onConfirm(value) {
                    _this2.data.push(value);
                    _this2.$refs.autocomplete.setSelected(value);
                }
            });
        }
    }
});

/***/ }),

/***/ 966:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find or add a Fruit"
    }
  }, [_c('b-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "data": _vm.filteredDataArray,
      "placeholder": "e.g. Orange"
    },
    on: {
      "select": function (option) { return _vm.selected = option; }
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, [_c('template', {
    slot: "footer"
  }, [_c('a', {
    on: {
      "click": _vm.showAddFruit
    }
  }, [_c('span', [_vm._v(" Add new... ")])])]), _vm._v(" "), _c('template', {
    slot: "empty"
  }, [_vm._v("No results for " + _vm._s(_vm.name))])], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 967:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [],
            selected: null,
            isFetching: false
        };
    },

    methods: {
        // You have to install and import debounce to use it,
        // it's not mandatory though.
        getAsyncData: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (name) {
            var _this = this;

            if (!name.length) {
                this.data = [];
                return;
            }
            this.isFetching = true;
            this.$http.get('https://api.themoviedb.org/3/search/movie?api_key=bb6f51bef07465653c3e553d6ab161a8&query=' + name).then(function (_ref) {
                var data = _ref.data;

                _this.data = [];
                data.results.forEach(function (item) {
                    return _this.data.push(item);
                });
            }).catch(function (error) {
                _this.data = [];
                throw error;
            }).finally(function () {
                _this.isFetching = false;
            });
        }, 500)
    }
});

/***/ }),

/***/ 968:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find a movie"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "data": _vm.data,
      "placeholder": "e.g. Fight Club",
      "field": "title",
      "loading": _vm.isFetching
    },
    on: {
      "typing": _vm.getAsyncData,
      "select": function (option) { return _vm.selected = option; }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "media"
        }, [_c('div', {
          staticClass: "media-left"
        }, [_c('img', {
          attrs: {
            "width": "32",
            "src": ("https://image.tmdb.org/t/p/w500/" + (props.option.poster_path))
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_vm._v("\n                            " + _vm._s(props.option.title) + "\n                            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n                                Released at " + _vm._s(props.option.release_date) + ",\n                                rated "), _c('b', [_vm._v(_vm._s(props.option.vote_average))])])])])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            data: [],
            selected: null,
            isFetching: false,
            name: '',
            page: 1,
            totalPages: 1
        };
    },

    methods: {
        // You have to install and import debounce to use it,
        // it's not mandatory though.
        getAsyncData: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (name) {
            var _this = this;

            // String update
            if (this.name !== name) {
                this.name = name;
                this.data = [];
                this.page = 1;
                this.totalPages = 1;
            }
            // String cleared
            if (!name.length) {
                this.data = [];
                this.page = 1;
                this.totalPages = 1;
                return;
            }
            // Reached last page
            if (this.page > this.totalPages) {
                return;
            }
            this.isFetching = true;
            this.$http.get('https://api.themoviedb.org/3/search/movie?api_key=bb6f51bef07465653c3e553d6ab161a8&query=' + name + '&page=' + this.page).then(function (_ref) {
                var data = _ref.data;

                data.results.forEach(function (item) {
                    return _this.data.push(item);
                });

                _this.page++;
                _this.totalPages = data.total_pages;
            }).catch(function (error) {
                throw error;
            }).finally(function () {
                _this.isFetching = false;
            });
        }, 500),
        getMoreAsyncData: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
            this.getAsyncData(this.name);
        }, 250)
    }
});

/***/ }),

/***/ 970:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Selected:")]), _vm._v(" " + _vm._s(_vm.selected))]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Find a movie"
    }
  }, [_c('b-autocomplete', {
    attrs: {
      "data": _vm.data,
      "placeholder": "e.g. Fight Club",
      "field": "title",
      "loading": _vm.isFetching,
      "check-infinite-scroll": true
    },
    on: {
      "typing": _vm.getAsyncData,
      "select": function (option) { return _vm.selected = option; },
      "infinite-scroll": _vm.getMoreAsyncData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "media"
        }, [_c('div', {
          staticClass: "media-left"
        }, [_c('img', {
          attrs: {
            "width": "32",
            "src": ("https://image.tmdb.org/t/p/w500/" + (props.option.poster_path))
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "media-content"
        }, [_vm._v("\n                            " + _vm._s(props.option.title) + "\n                            "), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n                                Released at " + _vm._s(props.option.release_date) + ",\n                                rated "), _c('b', [_vm._v(_vm._s(props.option.vote_average))])])])])]
      }
    }])
  }, [_c('template', {
    slot: "footer"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page > _vm.totalPages),
      expression: "page > totalPages"
    }],
    staticClass: "has-text-grey"
  }, [_vm._v(" Thats it! No more movies found. ")])])], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'String, Number',
        values: '—',
        default: '—'
    }, {
        name: '<code>data</code>',
        description: 'Options / suggestions',
        type: 'Array<String>, Array<Number>, Array<Object>',
        values: '—',
        default: '—'
    }, {
        name: '<code>field</code>',
        description: 'Property of the object (if <code>data</code> is array of objects) to use as display text, and to keep track of selected option',
        type: 'String',
        values: '—',
        default: '<code>value</code>'
    }, {
        name: '<code>custom-formatter</code>',
        description: 'Function to format an option to a string for display in the input as alternative to <code>field</code> prop)',
        type: 'Function',
        values: '—',
        default: ''
    }, {
        name: '<code>clear-on-select</code>',
        description: 'Clear input text on select',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>open-on-focus</code>',
        description: 'Open dropdown list on focus',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>keep-first</code>',
        description: 'The first option will always be pre-selected (easier to just hit enter or tab)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>size</code>',
        description: 'Vertical size of input, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '—'
    }, {
        name: '<code>expanded</code>',
        description: 'Makes input full width when inside a grouped or addon field',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>loading</code>',
        description: 'Add the loading state to the input',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>icon</code>',
        description: 'Icon name to be added',
        type: 'String',
        values: '—',
        default: '—'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '<code>mdi</code>, <code>fa</code>, <code>fas</code>, <code>far</code>, <code>fad</code>, <code>fal</code>',
        default: '<code>mdi</code>'
    }, {
        name: '<code>maxlength</code>',
        description: 'Same as native <code>maxlength</code>, plus character counter',
        type: 'String, Number',
        values: '—',
        default: '—'
    }, {
        name: '<code>check-infinite-scroll</code>',
        description: 'Makes the component check if list reached scroll end and emit <code>infinite-sroll</code> event.',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: 'Any native attribute',
        description: '—',
        type: '—',
        values: '—',
        default: '—'
    }],
    slots: [{
        name: 'default',
        description: '',
        props: '<code>option: String|Object</code>, <code>index: Number</code>'
    }, {
        name: '<code>empty</code>',
        description: 'Show like an option if <code>data</code> array prop is empty',
        props: '—'
    }, {
        name: '<code>header</code>',
        description: 'Show a custom header as first option',
        props: '—'
    }, {
        name: '<code>footer</code>',
        description: 'Show a custom footer as last option',
        props: '—'
    }],
    events: [{
        name: '<code>input</code>',
        description: 'Triggers when value is changed',
        parameters: '<code>value: String|Number</code>'
    }, {
        name: '<code>select</code>',
        description: 'Triggers when an option is selected or unset',
        parameters: '<code>option: String|Number|Object</code>'
    }, {
        name: '<code>focus</code>',
        description: 'Triggers when input has received focus',
        parameters: '<code>event: $event</code>'
    }, {
        name: '<code>blur</code>',
        description: 'Triggers when input has lost focus',
        parameters: '<code>event: $event</code>'
    }, {
        name: '<code>typing</code>',
        description: 'Triggers when user is typing',
        parameters: '<code>value: String</code>'
    }, {
        name: '<code>[any].native</code>',
        description: 'Listen to any native event, e.g. <code>click.native</code>',
        parameters: '<code>event: $event</code>'
    }, {
        name: '<code>infinite-scroll</code>',
        description: 'Triggers when <code>.dropdown-list</code> has reached scroll end',
        parameters: '—'
    }],
    methods: [{
        name: '<code>checkHtml5Validity</code>',
        description: 'Check validation of HTML5 (add the message and type/color), also updates the <code>isValid</code> property',
        return: '<code>isValid: Boolean</code>'
    }, {
        name: '<code>focus</code>',
        description: 'Set focus (internally uses the native <code>.select()</code> method)',
        return: '—'
    }, {
        name: '<code>setSelected(selected: Any)</code>',
        description: 'Select an option by an object (same type of <code>data</code> property)',
        return: '—'
    }]
}]);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.e2e8efd6c9ac3a5132e9.js